<template>
    <div>
        <bc-tooltip class="hidden-sm-and-down">
            <template slot="activator">
                <v-btn icon v-if="show_button" @mouseup.left="openDialog()">
                    <v-icon>low_priority</v-icon>
                </v-btn>
            </template>
            {{ $t(`lang.${tooltip}`) }}
        </bc-tooltip>
        <bc-dialog :value="reorder_dialog" content-class="dialog-overflow-hidden">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('lang.'+ this.title) }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="reorder_dialog"
                        :dialog-status="reorder_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pa-0">
                    <draggable
                        class="list-group mx-auto pl-0 gray-bg"
                        tag="ul"
                        v-model="current_positions"
                        v-bind="dragOptions"
                        @start="prepPositions(current_positions)"
                        @end="updatePositions(current_positions)"
                        handle=".handle"
                    >
                        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                            <li
                                class="list-group-item text-truncate pa-3 striped handle clickable"
                                v-for="(curr_item, index) in reorderItems"
                                :key="`position-${curr_item[primaryId]}`"
                            >
                                <v-icon class="">drag_indicator</v-icon>
                                <span class="fs-20 cursor-pointer">
                                    <slot :item="curr_item" :index="index">
                                        {{ `${curr_item.sort_order || index} - ${curr_item.machine_name}` }}
                                    </slot>
                                </span>
                            </li>
                        </transition-group>
                    </draggable>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="close()">{{$t('lang.cancel')}}</v-btn>
                    <v-btn color="success" @mouseup.left="$emit('save', current_positions)">{{$t('lang.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>

import draggable from "vuedraggable";

export default {
    components: {
        draggable
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        primaryId: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: 'reorder'
        },
        tooltip: {
            type: String,
            default: 'reorder'
        },
        perm: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            reorder_dialog: false,
            positions_before: [],
            current_positions: [],
            drag: false,
        };
    },
    computed: {
        reorderItems(){
            return this.current_positions && this.current_positions.length > 0 ? this.items.slice().sort((a, b) => +this.current_positions.indexOf(a[this.primaryId]) - +this.current_positions.indexOf(b[this.primaryId])) : [];
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        show_button(){
            return !this.perm || this.hasPerm(this.perm);
        }
    },
    methods: {
        prepPositions(pos){
            this.positions_before = pos;
            this.drag = true;
        },
        updatePositions(pos){
            this.drag = false;
            if(JSON.stringify(pos) != JSON.stringify(this.positions_before)){
                this.current_positions = pos;
            }
        },
        openDialog(){
            this.$store.commit('toggleModalLoader', false);
            this.reorder_dialog = true;
            if(this.items && this.primaryId) this.current_positions = this.items.map(item => item[this.primaryId]);
        },
        close(){
            this.reorder_dialog = false;
        }
    },
};

</script>